import { h } from "omi";
import isString from "lodash-es/isString";

type Props = {
  data:
    | {
        type: "success" | "error";
        title: string;
        isClosing?: boolean;
        link?: string | (() => void);
      }
    | undefined;
};
export function ActionNotification({ data }: Props) {
  if (!data) return <div></div>;

  const { isClosing, type, link, title } = data;
  const isLink = isString(link);

  const renderLinkElement = () => {
    if (isLink) {
      return (
        <a
          target="_blank"
          href={link}
          class="whitespace-nowrap cursor-pointer text-secondary hover:text-secondary-hover underline underline-offset-2"
        >
          {title}
        </a>
      );
    }

    return (
      <button onClick={link} class="whitespace-nowrap cursor-pointer underline text-secondary underline-offset-2">
        {title}
      </button>
    );
  };

  return (
    <div
      class={`absolute -top-8 flex flex-nowrap items-center left-1/2 -translate-x-1/2 rounded-[10px] bg-white px-2.5 py-1 text-xs text-secondary space-x-2 border border-gray-300 ${
        isClosing ? "animate-fadeOutFast" : "animate-fadeInFast"
      }`}
    >
      <div class="flex items-center space-x-2 flex-nowrap">
        <span class="relative flex">
          <span
            class={`absolute inline-flex h-full w-full animate-ping rounded-full ${type === "success" ? "bg-success-400" : "bg-error-400"} opacity-75`}
          ></span>
          <span
            class={`relative inline-flex size-2 rounded-full ${type === "success" ? "bg-success-500" : "bg-error-500"}`}
          ></span>
        </span>
        {link ? renderLinkElement() : <p class="whitespace-nowrap text-secondary">{title}</p>}
      </div>
    </div>
  );
}
